module.exports = __webpack_public_path__ + "img/1416901-90-0.4bfbd288.png";